import { gql, useQuery } from '@apollo/client'

const GET_LEADS_FULL = gql`
  query CoachingLeads {
    coachingInquiries {
      id
      createdAt
      viewedAt
      contactedAt
      contactMethod
      intent
      contact {
        id
        firstName
        lastName
        email
        phone
        externalId
        banned
      }
    }
    currentUser {
      attributes {
        ... on Coach {
          freeTierLimitsReached
        }
      }
    }
    coachingLeadContactMethodOptions {
      label
      value
    }
  }
`

const GET_COACHING_INQUIRIES_ONLY = gql`
  query CoachingLeadsInquiriesOnly {
    coachingInquiries {
      viewedAt
      contactedAt
      contactMethod
    }
  }
`

const GET_LEAD = gql`
  query CoachingInquiryQuery($id: ID!) {
    coachingInquiry(id: $id) {
      id
      intent
      createdAt
      viewedAt
      contactMethod
      contact {
        firstName
        lastName
        email
        phone
        phoneNumber
        externalId
        banned
      }
      coachProfile {
        id
      }
      questionnaire {
        question
        answer
      }
    }
  }
`

export function useGetLeads({ onlyCoachingInquiries = false } = {}) {
  return useQuery(
    onlyCoachingInquiries ? GET_COACHING_INQUIRIES_ONLY : GET_LEADS_FULL,
    {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    },
  )
}

export function useGetLead(leadId) {
  return useQuery(GET_LEAD, {
    variables: { id: leadId },
  })
}
